"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchUnixToMs = switchUnixToMs;
exports.daysInMonthStr = daysInMonthStr;
exports.daysInMonthInt = daysInMonthInt;
const luxon_1 = require("luxon");
/**
 * @description Will correct a time to make sure it is stored in ms not s.
 * @description Convention with db to allways store in ms.
 * @param number: unix time in either s or ms
 */
function switchUnixToMs(time) {
    if (time.toString().length > 10) {
        /// Time is already in ms
        return time;
    }
    else {
        /// Time not in ms so convert from s to ms
        return time * 1000;
    }
}
/**
 * How many days in month. (takes strings of numbers)
 * @param year
 * @param month
 * @returns default 31 if cant parse strings
 */
function daysInMonthStr(year, month) {
    const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);
    if (yearNum && monthNum) {
        const tmpLuxonDatetime = luxon_1.DateTime.fromObject({
            year: yearNum,
            month: monthNum,
        });
        if (tmpLuxonDatetime.isValid) {
            return tmpLuxonDatetime.daysInMonth;
        }
    }
    return 31;
}
/**
 * How many days in month.
 * @param year
 * @param month
 * @returns default 31 if cant parse strings
 */
function daysInMonthInt(year, month) {
    if (year && month) {
        const tmpLuxonDatetime = luxon_1.DateTime.fromObject({
            year,
            month,
        });
        if (tmpLuxonDatetime.isValid) {
            return tmpLuxonDatetime.daysInMonth;
        }
    }
    return 31;
}
